import React from 'react';

const Vue_Instance_Options_expose = () => {
  return (
    <div>
      <h1>Vue_Instance_Options_expose Component</h1>
      <p>This is the Vue_Instance_Options_expose tutorial page.</p>
    </div>
  );
}

export default Vue_Instance_Options_expose;
